import { css } from "styled-components"

export const HideGrecaptchaBadge = css`
  .grecaptcha-badge {
    visibility: hidden;
  }
`
